import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // getIdTokenAsync() checks expiry and silently refreshes via Firebase securetoken
  // before deciding whether the user is authenticated.
  const token = await authService.getIdTokenAsync();
  if (token) {
    return true;
  }

  // Preserve the attempted URL so the login page can redirect back after sign-in
  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};
